import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { PropsBuilder } from '../__base/props-builder';

export class BreadcrumbsPropsBuilder extends PropsBuilder<'breadcrumbs'> {
  constructor(props: PartialPropsOf<'breadcrumbs'> | undefined) {
    super(props, { hasData: false, hasLabel: true });
  }
}
